import request from '@/utils/request'

const host = process.env.VUE_APP_SEARCH_API;
const host2 = process.env.VUE_APP_USER_API;
const orderhost = process.env.VUE_APP_ORDER_API;

export function getSearchRelate(condition) {
  let url = host + ("/search/relate")
  // console.log('筛选条件',JSON.stringify(condition))
  return request.post(url, condition)
}

export function getSearchData(condition) {
  let url = host + ("/search")
  return request.post(url, condition)
}

/**
 * 根据产品id和关键字，搜索关联产品列表
 * @param condition
 * @returns {*}
 */
export function getRelationProductData(condition) {
  let url = host + '/search/product'
  return request.post(url, condition)
}

/**
 * 根据产品id和关键字，搜索产品规格列表
 * @param condition
 * @returns {*}
 */
export function getRelatioProductOption(condition) {
  let url = host + "/search/product/relate"
  return request.post(url, condition)
}

/**
 * 搜索产品名称
 * @param keyword
 * @returns {*}
 */
export function getProductName(keyword) {
  let params = {
    keyword,
    pageNum: 1,
    pageSize: 10
  }
  return request.get(host + "/search/productName", {params})
}

// 简单查询-根据SkuCode左匹配模糊查询
export function searchBySkuCode(params) {
  return request({
    url: host+'search/searchBySkuCode',
    method: 'get',
    params
  })
}

// 简单查询-根据SkuCode左匹配模糊查询
export function memberBySkuCode() {
  return request({
    url: host2+'member',
    method: 'get',
  })
}
//商品详情上次显示样式
export function updateMemberProductViewType(productViewType) {
  return request.put(host2 + `member/updateMemberProductViewType/${productViewType}`)
}
//商品列表上次显示样式
export function updateMemberDetailViewType(productViewType) {
  return request.put(host2 + `member/updateMemberDetailViewType/${productViewType}`)
}
//商品包装新增
export function insertCustPack(params) {
  return request({
    url: orderhost+'oms-cust-pack/insertCustPack',
    method: 'post',
    data:params
  })
}
//商品包装查询
export function searchCustPack(params) {
  return request({
    url: orderhost+'oms-cust-pack/searchCustPack',
    method: 'get',
    params
  })
}
//商品包装精确查询
export function CustPackDetail(params) {
  return request({
    url: orderhost+`oms-cust-pack/CustPackDetail/${params}`,
    method: 'get',
  })
}
// 自定义包装商品删除
export function deleteCustPackDetail(params) {
  return request({
    url: orderhost+`oms-cust-pack-detail/deleteCustPackDetail/${params}`,
    method: 'delete',
  })
}
// 自定义包装商品编辑
export function updateCustPackDetail(params) {
  return request({
    url: orderhost+`oms-cust-pack-detail/updateCustPackDetail`,
    method: 'put',
    data:params
  })
}
// 自定义包装商品编辑
export function deleteCustPack(params) {
  return request({
    url: orderhost+`oms-cust-pack/deleteCustPack/${params}`,
    method: 'delete',
  })
}
// 自定义包装编辑
export function updateCustPack(params) {
  return request({
    url: orderhost+`oms-cust-pack/updateCustPack`,
    method: 'put',
    data:params
  })
}



// WEBPACK FOOTER //
// ./src/api/search.js